export default [
    { value: 'SMS', en: 'SMS', zh_CN: '短信', zh_HK: '短訊' },
    { value: 'Email', en: 'Email', zh_CN: '电子邮件', zh_HK: '電郵' },
    { value: 'Phone call', en: 'Phone call', zh_CN: '电话', zh_HK: '電話' },
]